/**
 * Where the API lives.
 *
 * On the web the app is served from the same origin as the API, so the origin
 * of the page is the right answer and nothing needs configuring.
 *
 * Inside the bundled mobile apps it is not: the page is served from
 * `capacitor://localhost` (iOS) or `http://localhost` (Android) by the WebView
 * itself, and pointing the API at that would call the app. Native builds must
 * therefore be built with REACT_APP_API_URL set to the public API origin.
 */

function isNativeShell(): boolean {
    return Boolean((globalThis as any).Capacitor?.isNativePlatform?.());
}

const configured = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

function resolveOrigin(): string {
    if (configured) return configured;
    if (isNativeShell()) {
        // Nothing sensible to fall back to: localhost is the app itself.
        throw new Error('REACT_APP_API_URL must be set when building the native apps');
    }
    return process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:3001';
}

export const API_URL = resolveOrigin();
export const SOCKET_URL = (process.env.REACT_APP_SOCKET_URL || API_URL).replace(/\/$/, '');
